import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "@reach/router";

import queryString from "query-string";

export const useUrlFilter = () => {
  const [itemList, setItemList] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setItemList(queryString.parse(location.search));
  }, [location]);

  const setUrlFilter = (query) => {
    let newQUery = { page: 1 };
    if (query) {
      const existingFilters = queryString.parse(location.search);
      newQUery = { ...existingFilters, ...query };
    }
    navigate(`${location.pathname}?${queryString.stringify(newQUery)}`);
  };

  return [itemList, setUrlFilter];
};
